import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { editActions, editMutations } from './types';
import {
	NAME as name, CRUMB_LABEL_KEY, DEPENDENT_TABLES_VOZIDLO as depTableNames, CUSTOMER_CONTACT_DETAILS, DUPLICITY_TABLE, CUSTOMER_FILES,
	VEHICLE_HISTORY, VEHICLE_INSURANCE_DETAILS, CUSTOMER_OFFERS, INSURANCE_REPORT,
} from '../constants';
import { apiProvider } from '../api';
import { apiProvider as CDBapiProvider } from '../vozidloCDB/api';

export const dropdownList = {
	VyrobekvozOzn: [],
	KatalyzatorPzn: [],
	PalivoPzn: [],
	OvkategPzn: [],
	OvdruhPzn: [],
	GarPzn: [],
};

export const edit = {
	ZakaznikkonId: null as number | null,
	BarvaKod: null as string | null,
	BarvaText: null as string | null,
	DokladDat: null as string | null,
	DoplnekMk: null as string | null,
	DzmAktualDat: null as string | null,
	DzmKmLimit: null as number | null,
	DzmPlatnostDat: null as string | null,
	EditDat: null as string | null,
	EditPracId: null as number | null,
	EditPracIdText: null as string | null,
	EmiseDat: null as Date | null,
	EmiseosvNr: null as string | null,
	GarKonecDat: null as Date | null,
	ExtWarrantyStartDat: null as Date | null,
	ExtWarrantyEndDat: null as Date | null,
	GarPzn: null as number | null,
	IbsKod: null as string | null,
	IbsMarketkod: null as number | null,
	IbsText: null as string | null,
	KaroserieNr: null as string | null,
	KatalyzatorPzn: null as number | null,
	LeasKonecDat: null as string | null,
	LeasplatcePrp: null as boolean | null,
	Leaspodminky: null as string | null,
	LeassmlouNr: null as string | null,
	LeaszakaznikId: null as number | null,
	LeaszakaznikIdText: null as string | null,
	Memo: null as string | null,
	ModelRok: null as string | null,
	MotorKod: null as string | null,
	MotorNr: null as string | null,
	Objem: null as number | null,
	OvdruhPzn: null as number | null,
	OvkategPzn: null as number | null,
	Oznam: null as string | null,
	PalivoPzn: null as number | null,
	PalivoPznAlter: null as number | null,
	PojistovnaId: null as number | null,
	PojistovnaIdText: null as string | null,
	PojistsmlNr: null as string | null,
	PrevodKod: null as string | null,
	PrevodKodVymazat: null as string | null,
	PrevodNr: null as string | null,
	PrevodTypVymazat: null as string | null,
	PrevodVyrDat: null as string | null,
	PristiEkDat: null as string | null,
	ProdejDat: null as Date | null,
	ProdejceprId: null as number | null,
	ProdejceprIdText: null as string | null,
	ProdejzdeOvPrp: null as boolean | null,
	ProdejzdePrp: null as boolean | null,
	Spz: null as string | null,
	StkDat: null as Date | null,
	StkplatDat: null as Date | null,
	TpNr: null as string | null,
	Typkod: null as string | null,
	TablPozice: null as string | null,
	TypkodText: null as string | null,
	VozidloId: null as number | null,
	VstupDat: null as string | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as string | null,
	VstupProvId: null as number | null,
	VstupProvIdText: null as string | null,
	Vybava: null as string | null,
	Vykon: null as number | null,
	VyrazenDat: null as string | null,
	VyrobaDat: null as string | null,
	VyrobaRok: null as null | Date,
	VyrobekvozOzn: null as string | null,
	VyrobekvozOznText: null as string | null,
	ZakaznikId: null as number | null,
	VozidloRidicPocet: null as number | null,
	ZakaznikIdText: null as string | null,
	PnvId: null as number | null,
	ProdejceOsobniCis: null as number | null,
	isTotalLoss: false as boolean | false,
	IsVINFoundInDealer: false as boolean | false,
	RelatedData: {
		SdaAktivniPoc: null as number | null,
		ZakazkaOtevrenaPoc: null as number | null,
		ZakazkaVsechnyPoc: null as number | null,
		PneusetNaSkladePoc: null as number | null,
		PneuskladId: null as number | null,
		OdlozenyServisPoc: null as number | null,
		ZakazkaPosledniOtevreniDat: null as string | null,
		ZakazkaPosledniNajezd: 0,
		Doklad2SmPoc: null as number | null,
	},
	isTextchanged: false,
	VehicleUpdateData: {
		RecordId: 0 as number | 0,
		VozidloId: null as number | null,
		SpzOld: null as string | null,
		SpzNew: null as string | null,
		VerifiedMode: null as string | null,
		VstupDat: null as null | Date,
		VstupPracId: null as number | null,
		EditDat: null as null | Date,
		EditPracId: null as number | null,
		VstupPracIdText: null as string | null,
		EditPracIdText: null as string | null,
		IsUpdateRC: false as boolean | false,
		Remarks: null as string | null,
		DealershipDetails: null as string | null,
	},
	ContactDetails: [] as any[] | null,
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	edit,
	depTableNames,
	depTableSettings: {
		[CUSTOMER_CONTACT_DETAILS]: {
			filter(state) {
				return {
					VozidloId: state.edit.VozidloId,
					ZakaznikId: state.edit.ZakaznikId
				};
			},
		},
		[DUPLICITY_TABLE]: {
			filter(state) {
				return {
					KaroserieNr: state.edit.KaroserieNr,
					VyrobekvozOzn: state.edit.VyrobekvozOzn,
					Spz: state.edit.Spz,
					VozidloId: state.edit.VozidloId,
					VyrazenPrp: 0,
				};
			},
		},
		[VEHICLE_HISTORY]: {
			filter(state) {
				return {
					VozidloId: state.edit.VozidloId,
				};
			},
		},
		[CUSTOMER_FILES]: {
			loadByEntityId: true,
			filter(state) { return { ZakaznikId: state.edit.ZakaznikId }; },
		},
		[INSURANCE_REPORT]: {
			filter(state) {
				return {
					VozidloId: state.edit.VozidloId,
					ZakaznikId: state.edit.ZakaznikId,
				};
			},
		},
		[VEHICLE_INSURANCE_DETAILS]: {
			filter(state) {
				return {
					VozidloId: state.edit.VozidloId,
					VIN: state.edit.KaroserieNr,
				};
			},
		},
		[CUSTOMER_OFFERS]: {
			filter(state) {
				return {
					VozidloId: state.edit.VozidloId,
					VIN: state.edit.KaroserieNr,
				};
			},
		}
	},
	localState: {
		isFromMerge: null as boolean | null,
		barvaSubKod: '__',
		barvaLakSubKod: '__',
		barvaInterieruSubkod: '__',
		showPolicyDialog: false as boolean,
		policyPopupTitle: '' as String,
		policyUpdateMode: false as boolean,
		insurancePolicyDetails: {
			Id: 0 as number,
			VIN: null as number | null,
			SaleDate: null as any | null,
			RegNo: null as string | null,
			OwnerName: null as string | null,
			OwnerPhNo: null as string | null,
			OwnerAddress: null as string | null,
			DealerKVPS: null as string | null,
			DealerName: null as string | null,
			UserId: null as number | null,
			PolicyType: null as string | null,
			PolicyVendor: null as string | null,
			PolicyPrice: null as number | null,
			PolicyPurDate: null as Date | null,
			PolicyStartDate: null as Date | null,
			PolicyEndDate: null as Date | null,
			Status: 0 as number,
			PolicyDocument: null as any,
			AddOns: null as string | null,
		},
		fileList: [] as any[],
		fileListEV: [] as any[],
	},
	extraActions: {
		async [editActions.VOZIDLO_TYP_KOD_SELECT_MAPPER]({ state, commit, dispatch }, { data }) {
			const resp = await apiProvider.typKodChange({ VyrobekVozOzn: data.vyrobekvozozn, Typkod: data.typkod });
			await commit(editMutations.VOZIDLO_TYP_KOD_CHANGE, resp.data);
		},
		async [editActions.SET_CDB_VOZIDLO]({ state, commit, dispatch }, data) {
			const resp = await CDBapiProvider.getEntity(data.cdbVozidloId);
			await commit(editMutations.MAP_CDB_VOZIDLO, resp.data);
		},
	},
	extraGetters: {},
	extraMutations: {
		[editMutations.MAP_CDB_VOZIDLO](state, [data]) {
			state.edit.VyrobekvozOzn = data.VyrobekVozOzn;
			state.edit.KaroserieNr = data.KaroserieNr;
			state.edit.Spz = data.Spz;
			state.edit.BarvaText = data.BarvaText;
			state.edit.BarvaKod = data.BarvaKod;
			state.edit.TypkodText = data.TypText;
			state.edit.Typkod = data.TypKod;
			state.edit.ProdejDat = new Date(data.ProdejDat);
			state.edit.StkDat = new Date(data.StkDat);
			state.edit.EmiseDat = new Date(data.EmiseDat);
			state.edit.StkplatDat = new Date(data.StkPlatDat);
			state.edit.MotorKod = data.MotorKod;
			state.edit.PrevodKod = data.PrevodKod;
			state.edit.PrevodNr = data.PrevodNr;
			state.edit.PrevodVyrDat = data.PrevodVyrDat;
			state.edit.Objem = data.Objem;
			state.edit.Vykon = data.Vykon;
			state.edit.VyrobaRok = new Date(data.VyrobaRok);
			state.edit.TablPozice = data.TablPozice;
			state.edit.ContactDetails = data.ContactDetails;
		},
		[editMutations.VOZIDLO_TYP_KOD_CHANGE](state, data) {
			state.edit.ModelRok = data.ModelRok;
			state.edit.DoplnekMk = data.DoplnekMk;
			state.edit.MotorKod = data.MotorKod;
			state.edit.Objem = data.Objem;
			state.edit.PalivoPzn = data.PalivoPzn;
			state.edit.PrevodKod = data.PrevodKod;
			state.edit.Typkod = data.Typkod;
			state.edit.TablPozice = data.TablPozice;
			state.edit.TypkodText = data.TypkodText;
			state.edit.Vykon = data.Vykon;
			if (data.VyrobekvozOzn) {
				state.edit.VyrobekvozOzn = data.VyrobekvozOzn;
			}
		},
		[editMutations.VOZIDLO_ZAKAZNIK_SELECT_MAPPER](state, { data }) {
			state.edit.ZakaznikId = data.value;
			state.edit.ZakaznikIdText = data.text;
		},
		[editMutations.VOZIDLO_KONTAKT_MERGE_DATA](state, data) {
			state.localState.isFromMerge = true;
			Object.keys(data).forEach((key) => {
				if (data[key]) {
					if (key === 'VyrobekvozOzn') {
						state.dropdownList.VyrobekvozOzn.forEach((oznaceni: { Value: number }) => {
							if (oznaceni === data[key]) {
								(state.edit as any)[key] = oznaceni.Value;
							}
						});
					} else if (key.indexOf('Dat') !== -1) {
						(state.edit as any)[key] = new Date(data[key]);
					} else if (key === 'PalivoPzn') {
						state.dropdownList.VyrobekvozOzn.forEach((oznaceni: { Value: number }) => {
							if (oznaceni === data[key]) {
								state.edit[key] = oznaceni.Value;
							}
						});
					} else {
						(state.edit as any)[key] = data[key];
					}
				}
			});
		},
		[editMutations.VOZIDLO_MODEL_SELECT_MAPPER](state, { data }) {
			if (!data.isClear) {
				state.edit.VyrobekvozOzn = data.vyrobekvozOzn;
				state.edit.Typkod = data.typkod;
				state.edit.TypkodText = data.text;
				state.edit.PalivoPzn = data.palivoPzn;
				state.edit.TablPozice = data.tablpozice;
				state.edit.Vykon = data.vykon;
				state.edit.Objem = data.objem;
			}
			state.edit.ModelRok = data.modelRok;
			state.edit.DoplnekMk = data.doplnekMk;
		},
		[editMutations.VOZIDLO_BARVA_SELECT_MAPPER](state, { data }) {
			state.edit.BarvaKod = data.value;
			state.edit.BarvaText = data.text;
		},
		[editMutations.VOZIDLO_PRODEJCE_SELECT_MAPPER](state, { data }) {
			state.edit.ProdejceprId = data.value;
			state.edit.ProdejceprIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.edit.ProdejceOsobniCis = data.osobniCis;
		},
		[editMutations.VOZIDLO_POJISTOVNA_SELECT_MAPPER](state, { data }) {
			state.edit.PojistovnaId = data.value;
			state.edit.PojistovnaIdText = data.text;
		},
		[editMutations.VOZIDLO_LEASING_SELECT_MAPPER](state, { data }) {
			state.edit.LeaszakaznikId = data.value;
			state.edit.LeaszakaznikIdText = data.text;
		},
	},
	props: {
		mode: null,
		karoserieNr: null as string | null,
		spz: null as string | null,
		vyrobekvozOzn: null as string | null,
		typkod: null as string | null,
		typkodText: null as string | null,
		modelRok: null as string | null,
		tablPozice: null as string | null,
		barvaKod: null as string | null,
		barvaText: null as string | null,
		prodejDat: null as Date | null,
		garPzn: null as number | null,
		tpNr: null as string | null,
		vyrobaRok: null as null | Date,
		motorNr: null as string | null,
		palivoPzn: null as number | null,
		ovkategPzn: null as number | null,
		ovdruhPzn: null as number | null,
		zakaznikId: null as number | null,
		zakaznikIdText: null as string | null,
		objem: null as number | null,
		vykon: null as number | null,
		vozidloId: null as number | null,
		contactDetails: [] as any[] | null,
	},
});
